import Buttons from '../../elements/modal/activateModalButtons';
import ChannelDown from '../../elements/images/channelDown';
import ChannelUp from '../../elements/images/channelUp';
import Container from '../../atoms/container/modalContainer';
import FlavourConfig from '../../../../shared/config/flavours';
import Logo from '../../atoms/images/modalLogo';
import QR from '../../atoms/images/activateModalQr';
import Subtitle from '../../atoms/text/modalSubtitle';
import Title from '../../atoms/text/modalTitle';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';

function ActivateZapperModal() {
  return (
    <Container>
      <ChannelUp />
      <Logo />
      <Title>
        {TranslationManager.get('MODAL.ACTIVATE.TITLE', FlavourConfig.appTitle)}
      </Title>
      <Subtitle>{TranslationManager.get('MODAL.ACTIVATE.SUBTITLE')}</Subtitle>
      <QR />
      <Buttons />
      <ChannelDown />
    </Container>
  );
}

export default ActivateZapperModal;
